/** Shows 'Art by: <PapiUser>' */
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import { Url } from '@wix/da-url';
import { ResourceType } from '@wix/da-shared-react/pkg/types/resource';
import {
  BiData,
  BiContextProvidedValue,
  UserNameClickBiEvent,
} from '@wix/da-bi/pkg/events';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import s from './Attribution.scss';

export interface Props {
  /** A gruser whose username will be the link's text */
  author?: PapiUser;
  /** (Optional) URL to use as link, if not given will link to author's profile */
  url?: string;
  className?: string;
}

export const Attribution: React.FC<Props> = ({ author, url, className }) => {
  const { t } = useTranslation();
  if (!author) {
    return null;
  }
  const link = url || Url.userLink(author.username);
  return (
    <span className={classnames(s['root'], className)}>
      {t('topicPage.attribution.artBy')}{' '}
      <BiLink
        href={link}
        className={s['link']}
        biData={BiData<UserNameClickBiEvent>({
          evid: 101,
          typeid: ResourceType.USER,
          itemid: author.userId,
          sectionname: BiContextProvidedValue,
        })}
      >
        {author.username}
      </BiLink>
    </span>
  );
};
Attribution.displayName = 'Attribution';
export default Attribution;
